import api from './api'

export const holidayService = {
  // Get all holidays
  getAllHolidays: async () => {
    const response = await api.get('/holidays')
    return response.data
  },

  // Get holiday by ID
  getHolidayById: async (id) => {
    const response = await api.get(`/holidays/${id}`)
    return response.data
  },

  // Create new holiday
  createHoliday: async (holidayData) => {
    const response = await api.post('/holidays', holidayData)
    return response.data
  },

  // Delete holiday
  deleteHoliday: async (id) => {
    const response = await api.delete(`/holidays/${id}`)
    return response.data
  }
}


